import { Fragment, useState } from "react";

import { Button, ButtonProps } from "@material-ui/core";

import { ServiceTimeSlotVariationDialog } from "../service_time_slot_variation_dialog";

export interface ServiceTimeSlotVariationButtonWithDialogProps extends Omit<ButtonProps, 'onClick'> {
  serviceId: string;
  date: Date;
}

export function ServiceTimeSlotVariationButtonWithDialog(
  props: ServiceTimeSlotVariationButtonWithDialogProps
) {
  const { serviceId, date, children, ...btnProps } = props;
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <Button 
        {...btnProps}
        onClick={() => setOpen(true)}
      >
        {children}
      </Button>
      <ServiceTimeSlotVariationDialog 
        serviceId={serviceId}
        date={date}
        open={open}
        setOpen={setOpen}
        title={`Operatività del ${date.toLocaleDateString()}`}
      />
    </Fragment>
  )
}